// @flow
import lz from 'lz-string';
import URI from 'urijs';
import { request } from 'axios';
import * as React from 'react';
import { Line, type LineProps } from 'Components/frameworks/line/Line.jsx';

type Props = {
  page: {
    lines: $ReadOnlyArray<LineProps>,
  },
};

function getClientSideInitialProps({
  appContext,
  location,
}: GetInitialPropsContext<{}, { locale?: string }>) {
  const params: { [string]: string } = {
    location: lz.compressToEncodedURIComponent(JSON.stringify(location)),
    commonContent: appContext.cmsContent,
    commonRelease: appContext.cmsRelease,
    pagesContent: appContext.pagesContent,
    pagesRelease: appContext.pagesRelease,
  };

  // don't add the locale is not needed since it would be redirected without it
  if (location.queryParams.locale) {
    params.locale = appContext.locale;
  }

  const requestOptions = {
    url: new URI(location.origin)
      .query('')
      .pathname('/api/dynamic-page')
      .toString(),
    method: 'GET',
    params,
    headers: {
      accept: 'application/json',
    },
  };

  return request(requestOptions)
    .then(response => response.data)
    .catch(err => Promise.resolve(err.response.data));
}

export function createDynamicPage() {
  const DynamicPage = ({ page }: Props) => <Line props={{ lines: page.lines }} />;
  // Avoid to inject server side code into client chunks
  if (typeof window !== 'undefined') {
    DynamicPage.getInitialProps = getClientSideInitialProps;
  } else {
    DynamicPage.getInitialProps = require('Server/dynamicPageService').default;
  }
  return DynamicPage;
}

export const DynamicPage = createDynamicPage();
